import React from "react";

const Info = () => (
<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.8 9.8" fill="none">
<path class="st0" d="M7.3,0.7c0.7,0.4,1.3,1,1.7,1.7C9.5,3.2,9.8,4,9.8,4.9S9.5,6.6,9.1,7.3c-0.4,0.7-1,1.3-1.7,1.7
	C6.6,9.5,5.8,9.8,4.9,9.8S3.2,9.5,2.4,9.1c-0.7-0.4-1.3-1-1.7-1.7C0.2,6.6,0,5.8,0,4.9s0.2-1.7,0.7-2.5c0.4-0.7,1-1.3,1.7-1.7
	C3.2,0.2,4,0,4.9,0S6.6,0.2,7.3,0.7z" fill="#0098F0" />
<path class="st1" d="M2.8,1.3C2.2,1.7,1.7,2.2,1.3,2.8C0.9,3.4,0.8,4.1,0.8,4.9S0.9,6.3,1.3,7c0.4,0.6,0.9,1.1,1.5,1.5
	C3.4,8.8,4.1,9,4.9,9S6.3,8.8,7,8.4C7.6,8.1,8.1,7.6,8.4,7C8.8,6.3,9,5.6,9,4.9S8.8,3.4,8.4,2.8C8.1,2.2,7.6,1.7,7,1.3
	C6.3,0.9,5.6,0.8,4.9,0.8S3.4,0.9,2.8,1.3z" fill="#f2f3f4" />
<path class="st2" d="M5.2,2.6v0.8H4.5V2.6H5.2z M5.2,4.1v3H4.5v-3H5.2z" fill="#0098F0" />
</svg>
);

export default Info;
